module.exports = __webpack_public_path__ + "static/media/podcast.f54d289e.png";